import { isBoolean, isFunction, isString } from "../TypeChecking/index.js";
const APSTAG_JS_URL = "https://c.amazon-adsystem.com/aax2/apstag.js";
const INVALID_BID = "_fp_invalid";
const BID_SLOT_NAME = "video";
const videoBidSet = new Set([
    "v_1noy7sw", "v_far6kg", "v_11zbzls", "v_onvh8g", "v_1x22igw", "v_8v7k0", "v_18n28sg", "v_vblqf4",
    "v_1kukdmo", "v_cgdce8", "v_17j3v9c", "v_j43lkw", "v_1riamtc", "v_5sn37k", "v_1e6u4g0", "v_tno64g",
    "v_1oqeozk", "v_gc7nr4", "v_10befb4", "v_mzxwxs", "v_1ve4y68", "v_44piww", "v_1ciwk5c", "v_z7g1s0",
    "v_1j6mtc0", "v_asfs3k", "v_15v6ayo", "v_ki1khs", "v_1sw8lq8", "v_76l24g", "v_1fks3cw", "v_r5rtog",
    "v_1m8icjk", "v_dubbb4", "v_13d9yio", "v_q1tg5c", "v_1yg0hds", "v_1mt6gw", "v_1a107pc", "v_wpjpc0",
    "v_1kkks8w", "v_c6dr0g", "v_17949vk", "v_iu4074", "v_1r8b1fk", "v_5inhts", "v_1dwuj28", "v_v1m51c",
    "v_1q4cnwg", "v_hq5mo0", "v_11pce80", "v_odvvuo", "v_1ws2x34", "v_2bs5xc", "v_1apz75s", "v_xeiosg",
    "v_1hdpgcg", "v_8zif40", "v_1428xz4", "v_l70jy8", "v_nulmo", "v_t8os1s", "v_adge0w", "v_qgsu80",
    "v_4kxv5s", "v_xzqtq8", "v_f4ifpc", "v_jaccg0", "v_4ay9s0", "v_qn1l34", "v_bnnif4", "v_nv5n9c",
    "v_81ssg0", "v_vwtvcw", "v_fqzitc", "v_kqs7pc", "v_1vjtog", "v_uge03k", "v_9x81s0", "v_ohmqdc",
    "v_5meccg", "v_z17aww", "v_do2kg0", "v_inv9c0", "v_rxv6kg", "v_mo2wao", "v_x7ngu8", "v_lp4bgg",
    "v_tqsjk0", "v_psgbuo", "v_xu4jy8", "v_jyoutc", "v_rbe3gg", "v_npjdhc"
]);
const displayBidSet = new Set([
    "ypca9s", "ozqhvk", "uyhrls", "kex728", "v8hczk", "npjdhc", "rbe3gg", "jyoutc", "xu4jy8", "psgbuo",
    "tqsjk0", "lp4bgg", "x7ngu8", "amznbidz17aww", "rxv6kg", "inv9c0", "do2kg0", "z17aww", "5meccg",
    "ohmqdc", "9x81s0", "uge03k", "1vjtog", "kqs7pc", "fqzitc", "vwtvcw", "81ssg0", "nv5n9c", "bnnif4",
    "qn1l34", "4ay9s0", "jaccg0", "f4ifpc", "xzqtq8", "4kxv5s", "qgsu80", "adge0w", "t8os1s", "nulmo",
    "l70jy8", "1428xz4", "8zif40", "1hdpgcg", "xeiosg", "1apz75s", "2bs5xc", "1ws2x34", "odvvuo", "11pce80",
    "hq5mo0", "1q4cnwg", "v1m51c", "1dwuj28", "5inhts", "1r8b1fk", "iu4074", "17949vk", "c6dr0g", "1kkks8w",
    "wpjpc0", "1a107pc", "1mt6gw", "1yg0hds", "q1tg5c", "13d9yio", "dubbb4", "1m8icjk", "r5rtog", "1fks3cw",
    "76l24g", "1sw8lq8", "ki1khs", "15v6ayo", "asfs3k", "1j6mtc0", "z7g1s0", "1ciwk5c", "44piww", "1ve4y68",
    "mzxwxs", "10befb4", "gc7nr4", "1oqeozk", "tno64g", "1e6u4g0", "5sn37k", "1riamtc", "j43lkw", "17j3v9c",
    "cgdce8", "1kukdmo", "vblqf4", "18n28sg", "8v7k0", "1x22igw", "onvh8g", "11zbzls", "far6kg", "1noy7sw",
    "sm7oxs", "1h17ym8", "8n0xds", "1ucogzk", "lyhfr4", "14tpts0", "9qzaww", "1i56c5c", "y5zklc", "1bhg2yo",
    "3391q8", "1w0m1a8", "nmf01s", "10xvif4", "gyoqv4", "1pcvs3k", "ua598g", "1d5dn9c", "4r6m0w", "1qgu5mo",
    "i2n4e8", "16hne2o", "bewv7k", "1jt3wg0", "ws1log", "1a3i41s", "1pb2tc", "1yiidq8", "q4bchs", "13fruv4",
    "dwt7nk", "1mb08w0", "r89q0w", "1fn9zpc", "792ygw", "1syqi2o", "kkjgu8", "153pf5s", "a0ywao", "1if5xj4",
    "yfz5z4"
]);
function isWindowWithApstag(a) {
    return ("apstag" in a &&
        ("init" in a.apstag && isFunction(a.apstag.init)));
}
function isExternalBidVariables(x) {
    return (("_fp_amz_enabled" in x) && isBoolean(x._fp_amz_enabled)) &&
        x._fp_amz_enabled;
}
export function isInvalidBid(bidString) {
    return !isString(bidString) || bidString == INVALID_BID;
}
function getOrInitializeAPSTagSdk(window, userData, gdpr, config) {
    if (isWindowWithApstag(window)) {
        if (!window['apstaginit'])
            window.apstag.init(config, () => { window['apstaginit'] = true; });
        return Promise.resolve(window.apstag);
    }
    else {
        (function (a9, a, p, s, t, A, g) {
            if (a[a9])
                return;
            function q(c, r) {
                a[a9]._Q.push([c, r]);
            }
            a[a9] = {
                init: (...args) => {
                    q("i", args);
                },
                fetchBids: (...args) => {
                    q("f", args);
                },
                setDisplayBids: () => { },
                targetingKeys: () => {
                    return [];
                },
                dpa: (...args) => {
                    q("di", args);
                },
                rpa: (...args) => {
                    q("ri", args);
                },
                upa: (...args) => {
                    q("ui", args);
                },
                _Q: []
            };
        })("apstag", window);
        return gdpr.then(gsdk => {
            return gsdk.amazon.allowPersonalizedAds() && gsdk.amazon.allowHeaderBidding();
        }).then(amazonEnabled => {
            if (amazonEnabled) {
                const apstag = window["apstag"];
                apstag.init(config, () => {
                    window['apstaginit'] = true;
                });
                if (!userData.isOptOut()) {
                    const apat = userData.getApat();
                    if (apat) {
                        apstag.rpa({
                            hashedRecords: [{ type: "email", record: apat }],
                            optOut: false
                        });
                    }
                }
                let script = window.document.head.querySelector("script[src='" + APSTAG_JS_URL + "']");
                if (!script) {
                    script = window.document.createElement("script");
                    script.src = APSTAG_JS_URL;
                    script.async = true;
                    window.document.head.appendChild(script);
                }
                return Promise.resolve(apstag);
            }
            else
                return Promise.reject("APSTAG NOT ENABLED");
        });
    }
}
export const DefaultVideoBidSlot = {
    slotID: BID_SLOT_NAME,
    mediaType: "video"
};
export class AmazonHBBaseImpl {
    window;
    gdprPromise;
    userData;
    config;
    exportGlobalVideoBid;
    constructor(window, gdprPromise, userData, config, exportGlobalVideoBid) {
        this.window = window;
        this.gdprPromise = gdprPromise;
        this.userData = userData;
        this.config = config;
        this.exportGlobalVideoBid = exportGlobalVideoBid;
        if (this.exportGlobalVideoBid) {
            const exportVariables = {
                _fp_amz_enabled: true,
                _fp_amz_page_load: true,
                _fp_amz_scp: null
            };
            Object.keys(exportVariables).forEach(k => {
                this.window[k] = exportVariables[k];
            });
        }
    }
    loadSdk() {
        console.log('[SHATSU] LOAD SDK');
        return getOrInitializeAPSTagSdk(this.window, this.userData, this.gdprPromise, this.config);
    }
    fetchBids(s) {
        const exportVideoBid = this.exportGlobalVideoBid && s.find(slot => slot.mediaType && slot.mediaType == "video");
        //todo: mark external load
        return this.loadSdk().then(sdk => {
            return new Promise((resolve) => {
                sdk.fetchBids({ slots: s }, (bids) => {
                    if (exportVideoBid) {
                        let encodedQS = null;
                        if (bids) {
                            const updatedExportParams = {
                                _fp_amz_enabled: true,
                                _fp_amz_scp: INVALID_BID,
                                _fp_amz_page_load: false
                            };
                            const videoBid = bids.find(bid => {
                                return bid.mediaType == "video";
                            });
                            if (videoBid) {
                                if (videoBid.encodedQsParams) {
                                    encodedQS = videoBid.encodedQsParams;
                                }
                                else if (videoBid.helpers?.encodedQsParams) {
                                    encodedQS = videoBid.helpers.encodedQsParams();
                                }
                                updatedExportParams._fp_amz_scp = encodedQS;
                            }
                            Object.keys(updatedExportParams).forEach(k => {
                                this.window[k] = updatedExportParams[k];
                            });
                        }
                    }
                    const floorThresholds = {
                        display: 3.0,
                        video: 5.0
                    };
                    bids.forEach(bid => {
                        if (!bid)
                            bid = {};
                        const bidId = bid['amznbid'];
                        if (videoBidSet.has(bidId)) {
                            bid['amz_high_yield'] = 'video';
                        }
                        else if (displayBidSet.has(bidId)) {
                            bid['amz_high_yield'] = 'display';
                        }
                        else {
                            bid['amz_high_yield'] = 'no';
                        }
                    });
                    resolve(bids);
                });
            });
        });
    }
    getExternalVideoBid() {
        const w = this.window;
        const timeout = this.config.bidTimeout;
        if (isExternalBidVariables(w)) {
            const cleanAndGet = () => {
                const flag = w._fp_amz_scp;
                w._fp_amz_scp = null;
                w._fp_amz_page_load = false;
                return flag;
            };
            if (w._fp_amz_page_load) {
                const startTime = new Date().getTime();
                return new Promise((resolve, reject) => {
                    const rec = () => {
                        if (w._fp_amz_scp && w._fp_amz_scp.trim().length > 0) {
                            if (w._fp_amz_scp != INVALID_BID)
                                resolve(cleanAndGet());
                            else
                                reject("invalid external bid");
                        }
                        else {
                            if (new Date().getTime() - startTime >= timeout) {
                                return reject("external bid search timeout");
                            }
                            else
                                w.setTimeout(rec, 50);
                        }
                    };
                    rec();
                });
            }
            else {
                if (w._fp_amz_scp && w._fp_amz_scp.trim().length > 0 && w._fp_amz_scp != INVALID_BID) {
                    return Promise.resolve(cleanAndGet());
                }
                else {
                    return null;
                }
            }
        }
        else
            return null;
    }
}
